import React from 'react';
import { ImageIcon } from 'lucide-react';

export default function PublicJobPhotos({ photos }) {
  const list = Array.isArray(photos) ? photos.filter((p) => p?.url) : [];
  if (list.length === 0) return null;

  return (
    <div className="public-job-photos">
      <h3 className="public-job-photos-title">
        <ImageIcon size={16} /> Job photos
      </h3>
      <ul className="public-job-photos-list">
        {list.map((p, i) => (
          <li key={p.url + i} className="public-job-photo-item">
            <a
              href={p.url}
              target="_blank"
              rel="noopener noreferrer"
              className="public-job-photo-link"
            >
              <img src={p.url} alt={p.note ? p.note : `Job photo ${i + 1}`} />
            </a>
            {p.note && (
              <p className="public-job-photo-note">{p.note}</p>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
